


















import { Component, Vue } from 'vue-property-decorator';
import { IProduct, IOffer } from '../data/model';
import BuyOfferModal from '../components/store/buy.vue';
@Component({ components: { BuyOfferModal } })
export default class Products extends Vue {
    private selectedOffer: IOffer | null = null;
    get products(): IProduct[] {
        return this.$store.getters.productsByLanguage;
    }
}
